{
  "en": {
    "answers": [
      {
        "id": 1328690,
        "text": "Clear and understandable content",
        "is_right": true
      },
      {
        "id": 1328691,
        "text": "Varied question types",
        "is_right": false
      },
      {
        "id": 1328692,
        "text": "Good visualizations",
        "is_right": false
      },
      {
        "id": 1328693,
        "text": "Practical examples",
        "is_right": false
      },
      {
        "id": 1328694,
        "text": "Flexible use (mobile/online)",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 22080,
        "name": "Evaluation"
      },
      {
        "id": 156068,
        "name": "Sample Question"
      },
      {
        "id": 156083,
        "name": "Survey Question"
      }
    ],
    "text": "Which aspects of the course did you particularly like?",
    "display_in_order": true,
    "is_poll_question": true,
    "type": 0,
    "created_at": "2025-09-02T17:19:28.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:56:05.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "explanation": "### Please select all answers that apply to your opinion.\n\nMultiple-choice questions are particularly useful in surveys to capture **several aspects at once**. This way, differentiated feedback can be collected, providing a more comprehensive picture of learners’ experiences, opinions, and preferences.",
    "has_explanation": true,
    "num_answers": 5
  },
  "de": {
    "answers": [
      {
        "id": 1329048,
        "text": "Verständliche Inhalte",
        "is_right": true
      },
      {
        "id": 1329049,
        "text": "Abwechslungsreiche Fragetypen",
        "is_right": false
      },
      {
        "id": 1329050,
        "text": "Gute Visualisierungen",
        "is_right": false
      },
      {
        "id": 1329051,
        "text": "Praxisnahe Beispiele",
        "is_right": false
      },
      {
        "id": 1329052,
        "text": "Flexible Nutzung (mobil/online)",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 9427,
        "name": "Musterfrage"
      },
      {
        "id": 14279,
        "name": "Umfragen/Evaluationen"
      },
      {
        "id": 35384,
        "name": "Feedback"
      }
    ],
    "text": "Welche Aspekte des Kurses haben Dir besonders gefallen?",
    "display_in_order": true,
    "is_poll_question": true,
    "type": 0,
    "created_at": "2025-09-03T08:00:33.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:30:57.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "explanation": "#### Bitte wähle alle Antworten aus, die auf Deine Meinung zutreffen.\n\nMultiple-Choice-Fragen eignen sich in Umfragen besonders gut, um **mehrere Aspekte gleichzeitig** zu erfassen. So lassen sich differenzierte Rückmeldungen sammeln und ein umfassenderes Bild der Erfahrungen, Einstellungen oder Präferenzen der Lernenden gewinnen.",
    "has_explanation": true,
    "num_answers": 5
  }
}
